import styled from "styled-components"
import noiseImage from './noise.svg'

export default styled.div`
    display: flex;
    position: relative;
    z-index: 0;
    box-sizing: border-box;
    min-height: 100vh;
    position: relative;
    overflow: hidden;
    padding: 0;
    margin: 0;
    flex-direction: row;
    min-height: 550px;

    &::after {
        z-index: 1;
        filter: contrast(170%) brightness(90%);
        content: ' ';
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-image:
            linear-gradient(-1.25deg, #9e7b234d, #bf9e4580, #f6cb5980 31.5%, #f3c23f00 31.7%),
            radial-gradient(farthest-corner at 8px 40px, #c7812154, #a5550a00),
            radial-gradient(farthest-corner at -16px 30px, #ffad3d87, #a5550a00),
            radial-gradient(farthest-corner at 48px 30px, #ffad3d, #a5550a00),
            linear-gradient(70deg, #b16c0f50, #924c0c9e 76%),
            url(${noiseImage});
    }

    @media screen and (max-width: 1260px) {
        flex-direction: column;
        width: 100%;
    }


    @media screen and (max-height: 1100px)  {
        &::after {
            background-image:
            linear-gradient(-1.25deg, #9e7b234d, #bf9e4580, #f6cb5980 21.5%, #f3c23f00 21.7%),
            radial-gradient(farthest-corner at 8px 40px, #c7812154, #a5550a00),
            radial-gradient(farthest-corner at -16px 30px, #ffad3d87, #a5550a00),
            radial-gradient(farthest-corner at 48px 30px, #ffad3d, #a5550a00),
            linear-gradient(70deg, #b16c0f50, #924c0c9e 76%),
            url(${noiseImage});
        }
    }
    @media screen and (max-width: 1260px)  {
        &::after {
            background-image:
            linear-gradient(-1.25deg, #9e7b234d, #bf9e4580, #f6cb5980 21.5%, #f3c23f00 21.7%),
            radial-gradient(farthest-corner at 8px 40px, #c7812154, #a5550a00),
            radial-gradient(farthest-corner at -16px 30px, #ffad3d87, #a5550a00),
            radial-gradient(farthest-corner at 48px 30px, #ffad3d, #a5550a00),
            linear-gradient(70deg, #b16c0f50, #924c0c9e 76%),
            url(${noiseImage});
        }
    }
`